import { NotFound } from 'components/common/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultPanel from './page/DefaultPanel';

export default function DefaultPanelFeature() {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={`${path}/`}>
          <DefaultPanel />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </div>
  );
}
